import BranchDto from '@/models/Branches/BranchDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import DeskDto from '@/models/Desks/DeskDto';
import ContactDto from '@/models/Contacts/ContactDto';
import EmailTemplateDto from '@/models/EmailTemplates/EmailTemplateDto';
import UserDto from '@/models/Users/UserDto';
import CampaignStatus from '@/models/Campaigns/CampaignStatus';
import ActivityCategoryDto from '@/models/Activities/ActivityCategoryDto';


export default class CampaignDto extends BaseAgencyScopeEntityDto {
    status: CampaignStatus = CampaignStatus.Draft;
    ownerId = '';
    owner: AgencyUserDto = new AgencyUserDto();
    branchId = '';
    branch: BranchDto = new BranchDto();
    deskId = '';
    desk: DeskDto = new DeskDto();
    categoryId = '';
    category: ActivityCategoryDto | null = null;
    name = '';
    emailTemplateId = '';
    emailTemplate: EmailTemplateDto = new EmailTemplateDto();
    isEmailOverrideFrom = false;
    emailFromFirstName = '';
    emailFromLastName = '';
    emailFromAddress = '';
    emailSubject = '';
    emailMergeField1 = '';
    emailMergeField2 = '';
    emailMergeField3 = '';
    emailMergeField4 = '';
    emailMergeField5 = '';
    isTest = false;
    testEmailAddresses = '';
    //campaignContacts: CampaignContactDto[] = [];
}
